<template>
  <ListeSecteurParametres />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListeSecteurParametres from "@/components/Parametres/ListeSecteurParametres.vue";

export default defineComponent({
  name: "ListeSecteurParametresPage",
  components: {
    ListeSecteurParametres,
  },
});
</script>

